<ion-toolbar [@showInOutAnimation] color="secondary">
  <ion-buttons slot="start">
    <ion-button [disabled]="!previousPropertyId" (click)="previous()">
      <ion-icon slot="start" name="chevron-back-circle-outline"></ion-icon>Previous
    </ion-button>
  </ion-buttons>
  <ion-title>{{ currentPropertyDisplayIndex | redDashIfEmpty }} of {{ totalProperties | redDashIfEmpty }}</ion-title>
  <ion-buttons slot="end">
    <ion-button [disabled]="!nextPropertyId" (click)="next()">
      <ion-icon slot="end" name="chevron-forward-circle-outline"></ion-icon>Next
    </ion-button>
  </ion-buttons>
</ion-toolbar>
